import { Box, Card, CardContent, CardHeader, Divider } from '@material-ui/core'
import React from 'react'
import { Line } from 'react-chartjs-2'

function LineChartTwoAxis({
    labels=[], valuesAxis1=[], valuesAxis2=[], title, height=120
}) {
    const data = {
        labels: labels,
        datasets: [
            ...valuesAxis1.map( item => ({...item, yAxisID: 'y-axis-1'})),
            ...valuesAxis2.map( item => ({...item, yAxisID: 'y-axis-2'}))
        ],
    }
      
    const options = {
        scales: {
          yAxes: [
            {type: 'linear', display: true, position: 'left', id: 'y-axis-1'},
            {type: 'linear', display: true, position: 'right', id: 'y-axis-2', gridLines: {drawOnArea: false}},
          ],
        },
    }

    return (
        <Card>
            <CardHeader title={title} />
            <Divider />
            <CardContent>
                <Box style={{height: (height*3)}}>
                    <Line data={data} options={options} height={height}/>
                </Box>
            </CardContent>
        </Card>
    )
}

export default LineChartTwoAxis
